import DashboardLayout from "../components/common/DashboardLayout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import EventIcon from '@mui/icons-material/Event';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import DateRangeIcon from '@mui/icons-material/DateRange';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const mainListItemsArray = [
  {
    id: 1,
    label: "Dashboard",
    link: "/investor",
    icon: <DashboardIcon />,
  },
  {
    id: 2,
    label: "Total Clients",
    link: "/investor/total-clients",
    icon: <GroupIcon />,
  },
  {
    id: 3,
    label: "New Clients Today",
    link: "/investor/new-clients-today",
    icon: <PersonAddIcon />,
  },
  {
    id: 4,
    label: "Total Subscribers",
    link: "/investor/total-subscribers",
    icon: <SubscriptionsIcon />,
  },
  {
    id: 5,
    label: "Active Users",
    link: "/investor/active-users-yesterday",
    icon: <TrendingUpIcon />,
  },
  {
    id: 6,
    label: "Active Subscribers",
    link: "/investor/active-subscribers",
    icon: <VerifiedUserIcon />,
  },
    {
    id: 5,
    label: "App Events",
    link: "/investor/app-events",
    icon: <EventIcon />,
        children: [
          {
            id: "1-1",
            label: "User Visit Count",
            link: "/investor/user-visit-count",
            icon: <PersonAddIcon />,
          },
          {
            id: "1-1",
            label: "Event Log User Details",
            link: "/investor/event-log-user-details",
            icon: <EventAvailableIcon />,
          },
          {
            id: "1-3",
            label: "User Activity",
            link: "/investor/user-activity",
            icon: <DateRangeIcon />,
          },
          // {
          //   id: "1-2",
          //   label: "Event Log Date Wise",
          //   link: "/investor/event-log-date-wise",
          //   icon: <DateRangeIcon />,
          // },
        ]
  },
   {
    id: 7,
    label: "Marketing Spend",
    link: "/investor/marketing-spend",
    icon: <CurrencyRupeeIcon />,
  },
];

export default function InvestorDashboardLayout() {
  return <DashboardLayout mainListItems={mainListItemsArray} hideNavbar />;
}
 